<div>
  <span> Pampamed</span>
  <span> &copy; 2025</span>
</div>
<div class="ms-auto">
  Administrada por
  <a href="https://buenosairesit.com/" target="_blank"> © Buenos Aires IT 1994/2025</a>
</div>
